
import React, {Component} from 'react';
import ColorPicker from 'rc-color-picker';
import ImageProcessor from './../../utils/ImageProcessing';
import { Button, Input, Tooltip } from 'antd';
import ReactGA from 'react-ga';

import Fade from './../../animation/Fade';

import 'rc-color-picker/assets/index.css';
import './styles.css';
import loading from './../../img/loading.gif';

class Image extends Component {

	constructor(props) {
		super(props);
		this.state = {
			trimmed: false,
			blob: null,
		};
	}

	colorClose(colorObj) {
		this.props.onColorChange(colorObj.color)
		this.setState({
			color: null
		})
	}

	changeColor(colorObj) {
		this.setState({
			color: colorObj.color
		})
	}

	dropColor() {
		this.props.onColorChange(null)
		this.setState({
			color: null
		})
	}

	getColor() {
		return this.state.color || this.props.file.color
	}

	onNameChange(v){
		this.props.onNameChange(v)
	}

	showColour(type) {
		return !(type === "Hoodie" || type === 'T-Shirt');
	}

	render() {
		if(!this.props.file.processedSrc){
			ImageProcessor.trimCanvasFromSrc(this.props.file.preview, (src) => {
			  this.props.file.processedSrc = src;
				this.setState({blob: src})
			});
		}

		let thumb = this.props.file.processedSrc ? this.props.file.processedSrc : loading

		return (
			<div>
			<Fade>
				<div className="img-card">
					<div>
						<div className="img-image grow" style={{
							backgroundColor: this.getColor()
						}}>
							<img src={thumb} alt={this.props.file.name} />
						</div>
					</div>
					<div className="img-input">
						<Input
							value={this.props.file.name}
							onChange={({ target }) => this.onNameChange(target.value)} />
					</div>
					<div className="img-cp">
					{
						this.showColour(this.props.type) ?
						<ColorPicker
							className="color-picker"
							enableAlpha={false}
							animation="slide-up"
							color={this.getColor()}
							onChange={(colorObj) => this.changeColor(colorObj)}
							onClose={(colorObj) => this.colorClose(colorObj)}
						/> : ''
					}

					</div>
					<Tooltip title="Download Image">
						<Button type="primary" icon="download" onClick={() => {
							ReactGA.event({
					      category: 'Download',
					      action: 'Download Individual',
					      label: this.props.type
					    });
							ImageProcessor.drawAndSave(this.props.file.preview, this.getColor(), this.props.file.name, this.props.type)
						}}/>
					</Tooltip>
					<Tooltip title="Reset to Global Color">
						<Button type="primary" icon="reload" onClick={() => {this.dropColor()}}/>
					</Tooltip>
					<Tooltip title="Duplicate Image">
						<Button type="primary" icon="copy" onClick={() => {this.props.duplicate()}} />
					</Tooltip>
					<Tooltip title="Delete Image">
						<Button type="danger" icon="delete" onClick={() => {this.props.onRemove()}} />
					</Tooltip>
				</div>
			</Fade>
			</div>
		)
	}
}

export default Image;



// WEBPACK FOOTER //
// ./src/components/image/index.js